import { useCallback } from 'react';

import type { Ref, RefCallback } from 'react';

/**
 * Merges multiple refs into a single callback ref.
 * Useful when a component needs both an internal ref and a forwarded ref.
 */
export function useMergedRef<T>(
  ...refs: (Ref<T> | undefined)[]
): RefCallback<T> {
  return useCallback(
    (element: T | null) => {
      refs.forEach((ref) => {
        if (typeof ref === 'function') {
          ref(element);
        } else if (ref && 'current' in ref) {
          (ref as React.MutableRefObject<T | null>).current = element;
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  );
}
